export const EXTERNAL_SETTINGS_MODIFY = "EXTERNAL_SETTINGS_MODIFY"

import { db } from "../../../mp-database"

export const getIntegrations = () => {
  return dispatch => {
    setExternalSettings(dispatch, {
      integrations: [],
      isFetched: false
    })
    let integrations = []
    db.collection("integrations")
      .get()
      .then(sn => {
        sn.forEach(d => {
          integrations.push(d.data())
        })
        setExternalSettings(dispatch, {
          integrations,
          isFetched: true
        })
      })
  }
}

export const getIntegrationConfig = school_id => {
  return dispatch => {
    setExternalSettings(dispatch, {
      integrationsConfig: {},
      isFetchedConfig: false
    })
    db.collection("integrations_config")
      .doc(school_id)
      .get()
      .then(sn => {
        const config = sn.data()
        setExternalSettings(dispatch, {
          integrationsConfig: config || {},
          isFetchedConfig: true
        })
      })
  }
}

export const saveIntegrationConfig = (school_id, config) => {
  return dispatch => {
    setExternalSettings(dispatch, {
      isSavingConfig: true
    })
    db.collection("integrations_config")
      .doc(school_id)
      .set(config)
      .then(sn => {
        setExternalSettings(dispatch, {
          isSavingConfig: false,
          integrationsConfig: config
        })
      })
  }
}

export const setExternalSettings = (dispatch, payload) => {
  return dispatch({
    type: EXTERNAL_SETTINGS_MODIFY,
    payload
  })
}
